import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-approvals', storeModule.createStoreModule('management-reports-approvals'))
